import React from 'react';
import ReactDOM from 'react-dom';

// third party
import { BrowserRouter } from 'react-router-dom';


// project imports
import * as serviceWorker from './serviceWorker';
import App from './App';
import { AuthContextProvider } from './contexts/auth-context'
import { wagmiClient } from "./hooks/wagmi";
import { WagmiConfig } from "wagmi";

import config from './config';

// style + assets
import './assets/scss/style.scss';
import { StyledEngineProvider } from '@mui/material/styles';


//-----------------------|| REACT DOM RENDER  ||-----------------------//

ReactDOM.render(
    <WagmiConfig client={wagmiClient}>
        <AuthContextProvider>
            <BrowserRouter basename={config.basename}>
                 <StyledEngineProvider injectFirst>
                     <App />
                 </StyledEngineProvider>
            </BrowserRouter>
        </AuthContextProvider>
    </WagmiConfig>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
